import request from '../../library/request';
import setGlobalState, {resetGlobalState} from '../setGlobalState';
import {getState} from '../store.type';
import {TAvenueRange} from './avenueStats.type';

const getPid = () => getState().account.pid;

let latestRange: TAvenueRange | null = null;
let requestId = 0;

export const getLatestAvenueRange = () => latestRange;

export const resetAvenueStats = () => {
    requestId++;
    latestRange = null;
    resetGlobalState('avenueStats');
};

// ללא range השרת בוחר את הטווח הראשון שיש בו נתונים (שבוע → חודש → 30 יום → ...) ומחזיר אותו ב-res.range
export const getAvenueStats = async (range: TAvenueRange | null = null) => {
    const id = ++requestId;
    latestRange = range;
    const pid = getPid();
    const res = await request('avenueStats.getAvenueStats', 'get', `/package/${pid}/avenue/stats${range ? `?range=${range}` : ''}`);
    if(pid !== getPid() || id !== requestId) return; // the account changed, the store was reset or a newer range was requested meanwhile — drop this stale response
    if(res && typeof res === 'object') {
        latestRange = res.range;
        setGlobalState('avenueStats.stats', res.stats);
        setGlobalState('avenueStats.avenue', res.avenue);
        setGlobalState('avenueStats.rangeDates', res.rangeDates ?? null);
    }
};
